import { useMemo } from 'react';
import { useLocalizationContext, DATETIME_ELEMENT_STYLES } from '../../../contexts/LocalizationContext';
import { useFreelancerPageContext } from '../../FreelancerPageContext';

/**
 * @param {import('../../../types').Seller} seller
 * @returns
 */
const isSellerOnVacation = (seller) => {
    const { vacation } = seller;

    return vacation !== null && new Date(vacation?.endsAt * 1000).valueOf() > new Date().valueOf();
};

export const useSellerVacation = () => {
    const { seller } = useFreelancerPageContext();
    const { dateTimeFormat } = useLocalizationContext();

    const { isOnVacation, formattedVacationTillDate, vacationMessage, vacationEndDate, isContactAllowed } =
        useMemo(() => {
            const isOnVacation = isSellerOnVacation(seller);
            const vacationEndDate = isOnVacation ? seller?.vacation?.endsAt : null;
            const formattedVacationTillDate = isOnVacation
                ? dateTimeFormat(new Date(seller?.vacation?.endsAt * 1000), {
                      year: DATETIME_ELEMENT_STYLES.NUMERIC,
                      month: DATETIME_ELEMENT_STYLES.SHORT,
                      day: DATETIME_ELEMENT_STYLES.TWO_DIGIT,
                  })
                : null;

            return {
                isOnVacation,
                isContactAllowed: seller?.vacation?.isContactAllowed,
                formattedVacationTillDate,
                vacationEndDate,
                vacationMessage: seller?.vacation?.awayMessage || null,
            };
        }, [seller, dateTimeFormat]);

    return {
        isOnVacation,
        isContactAllowed,
        vacationEndDate,
        formattedVacationTillDate,
        vacationMessage,
    };
};
